<template>
  <div :class="brandCarouselClass">
    <div class="l-container">
      <template v-if="flickityActive">
        <flickity
          v-if="flickityEnabled"
          ref="flickity"
          class="flickity"
          :options="flickityOptions"
          role="region"
          aria-label="Carousel"
        >
          <template v-for="card in brandCards">
            <brand-card
              v-if="card"
              :key="card.i"
              v-bind="card"
            />
          </template>
        </flickity>
      </template>
      <div
        v-else
        class="c-brand-carousel__disabled-carousel"
      >
        <template v-for="card in brandCards">
          <brand-card
            v-if="card"
            :key="card.i"
            v-bind="card"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import BrandCard from "../card/BrandCard.vue";
import flickityActive from "./flickityActive";

export default {
  components: { BrandCard },
  mixins: [flickityActive],
  props: {
    brandCards: {
      type: Array,
      default: () => [],
    },
    backgroundColor: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      flickityOptions: {
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        freeScroll: false,
        cellAlign: "left",
        imagesLoaded: true,
        setGallerySize: true,
        autoPlay: true,
        contain: true
        // any options from Flickity can be used
        // https://flickity.metafizzy.co/options.html
      },
    };
  },
  computed: {
    brandCarouselClass() {
      let results = ['c-brand-carousel', 'u-padding-bottom-medium']
      if (this.backgroundColor) {
        results.push(" u-background-color-" + this.backgroundColor)
      }
      return results
    },
    carouselClass() {
      let results = ["c-content-card-carousel"];
      if (!this.carouselStart) {
        results.push("c-content-card-carousel--start-fade");
      }
      if (!this.carouselEnd) {
        results.push("c-content-card-carousel--end-fade");
      }
      return results;
    },
    flickityEnabled() {
      const brandCards = this.brandCards
      return brandCards && (brandCards.length > 0)
    }
  },
  watch: {
    async flickityEnabled() {
      await this.$nextTick();
      this.flickityActivator();
    },
  },
  methods: {
    slideEventListener() {},
    flickityActivator() {
      if (this.brandCards.length > 9) {
        this.flickityActive = true;
        return;
      }
      if (window.innerWidth < 900) {
        if (this.brandCards.length > 6) {
          this.flickityActive = true;
          return;
        }
      }
      this.flickityActive = false;
      return;
    },
  },
};
</script>

<style lang="scss">
.c-brand-carousel {
}
.c-brand-carousel__disabled-carousel {
  display: flex;
  align-items: center;
  gap: rem(10px);
}
.flickity {
  height: 100%;
  &:focus-visible {
    outline: none !important;
  }
}
</style>
